import AsyncDropdown from 'core/elements/dropdown/AsyncDropdown'
import useListAction from 'core/hooks/useListAction'
import useScopedPreferences from 'core/session/useScopedPreferences'
import { listAllAvailablePorts } from 'openstack/components/networks/actions'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { availablePortsSelector } from '../selectors'

export default function PortPicklist({
  disabled = false,
  name = 'port',
  label = 'Port',
  networkId = '',
  includeNoneOption = false,
  ...rest
}) {
  const { prefs } = useScopedPreferences()
  const { currentTenant } = prefs
  const { loading } = useListAction(listAllAvailablePorts)
  const ports = useSelector(availablePortsSelector)

  const options = useMemo(() => {
    // will need to filter out taken private IPs
    const filteredPorts = ports?.filter((port) => {
      if (port.project_id !== currentTenant) {
        return false
      }
      if (!networkId) {
        return true
      }
      return port.network_id === networkId
    })

    const portOptions = filteredPorts?.map((port) => {
      const ipAddressString = port.fixed_ips?.map((ip) => ip.ip_address)?.join(', ')
      return {
        label: `${ipAddressString} (${port.name || port.id})`,
        value: port,
        key: port.id,
      }
    })

    if (portOptions?.length === 0 && !includeNoneOption) {
      return [{ label: 'No ports available', value: null }]
    }

    return includeNoneOption ? [{ label: 'None', value: null }, ...portOptions] : portOptions
  }, [networkId, currentTenant, ports, includeNoneOption])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={options}
    />
  )
}
